import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';
import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { ListCompaniesQuery } from '@/core/domain/enterprise/Companies/Companies.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Col, Form, Row } from 'antd';

const TableExtraFilters = ({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListCompaniesQuery>) => {
  return (
    <Form>
      <Row gutter={[8, 8]}>
        <Col lg={4} span={24} md={4}>
          <OrderExtraFilter
            value={queryParams?.order}
            onChange={(value) =>
              setQueryParams((prev) => ({
                ...prev,
                order: value,
              }))
            }
          />
        </Col>

        <Col lg={4} span={24} md={4}>
          <ActiveExtraFilter
            value={queryParams?.active}
            onChange={(value) =>
              setQueryParams((prev) => ({
                ...prev,
                active: value as unknown as boolean,
              }))
            }
          />
        </Col>
      </Row>
    </Form>
  );
};

export default TableExtraFilters;
